import { IntlProvider } from "react-intl";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AuthContextProvider from "./authContextProvider";
import { useCommonContext } from './commonContextProvider';
import LocaleMessages from './lang';
import DigitalVisitingCard from "./pages/DigitalVisitingCard/DigitalVisitingCard";
import Error404 from './pages/Error404';
import English from "./pages/instantCashbackImage/English";
import Hindi from "./pages/instantCashbackImage/Hindi";
import PaymentCommunication from "./pages/PaymentCommunication";
import PaymentTransferHin from "./pages/paymentTransferImage/PaymentTransferHin";
import PaymentTransferEng from "./pages/paymentTransferImage/PaymentTransferEng";
import BijakPocketEn from "./pages/bijakPocket/BijakPocketEn";
import BijakPocketHi from "./pages/bijakPocket/BijakPocketHi";
import DiwaliContainer from "./pages/diwali2022/DiwaliContainer";
import WinnerContainer from "./pages/diwali2022/WinnerContainer";
import LeaderBoardContainer from "./pages/diwali2022/LeaderBoardContainer";
import ReferralEnglish from "./pages/referralImages/English";
import ReferralHindi from "./pages/referralImages/Hindi";
import DeliveryTerms from "./pages/DeliveryTerms"
import { JustBackButton } from "./pages/JustBackButton";
import RetailersContainer from "./pages/retailers-contest/RetailersContainer";
import RetailersWinnerContainer from "./pages/retailers-contest/RetailersWinnerContainer";

const App = () => {
  const { lang } = useCommonContext();
  return (
    <IntlProvider locale={lang} messages={LocaleMessages[lang]}>
      <BrowserRouter>
        <AuthContextProvider>
          <Routes>
            <Route path="/payment-communication/:lang" element={<PaymentCommunication />} />
            <Route path="/digital-visiting-card" element={<DigitalVisitingCard />} />
            {/* <Route path="/supplier-profile-list" element={<SupplierProfileList />} />
            <Route path="/supplier-profile/:id" element={<SupplierProfileExpand />} /> */}
            <Route path="/auto-cashback/en" element={<English />} />
            <Route path="/auto-cashback/hi" element={<Hindi />} />
            <Route path="/payment-transfer/en" element={<PaymentTransferEng />} />
            <Route path="/payment-transfer/hi" element={<PaymentTransferHin />} />
            <Route path="/bijak-pocket/en" element={<BijakPocketEn />} />
            <Route path="/bijak-pocket/hi" element={<BijakPocketHi />} />
            <Route path="/bijak-diwali-dhamaka-2023" element={<DiwaliContainer />}/>
            <Route path="/bijak-diwali-dhamaka-2023/winners/:id" element={<WinnerContainer />} />
            <Route path="/bijak-diwali-dhamaka-2023/leaderboard/:id" element={<LeaderBoardContainer />} />
            <Route path="/retailers-contest" element={<RetailersContainer />}/>
            <Route path="/retailers-contest/winners/:id" element={<RetailersWinnerContainer />} />
            <Route path="/referral/en" element={<ReferralEnglish />}  />
            <Route path="/referral/hi" element={<ReferralHindi />}  />
            <Route path="/just/delivery/terms" element={<DeliveryTerms />} />
            <Route path="/just/back/button" element={<JustBackButton />}  />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </AuthContextProvider>
      </BrowserRouter>
    </IntlProvider>
  )
}

export default App;
